// eslint-disable-next-line @typescript-eslint/no-explicit-any
const locale: { [key: string]: any } = {
  BODO: {
    website_url: 'https://boopdoge.com/',
    telegram_url: 'https://t.me/BoopDoge_Token',
    x_url: 'https://x.com/BoopDoge_Token',
    guide_url:
      'https://catsolhat.medium.com/introducing-the-first-catsolhat-launchpad-project-boopdoge-4e136347e53f',
    description:
      '<p>BoopDoge is a community-driven meme coin inspired by the urge to boop a dog on the nose. Our mission is to help passionate dog lovers and crypto enthusiasts achieve financial freedom.</p> <p>BoopDoge will be a flagship for emerging DeFi and meme culture on Solana. This is part of a larger plan to strengthen the creator culture on Solana as BoopDoge continues to integrate into the broader ecosystem.</p>',
    eligibility: (eligibleAmount: number) =>
      `<p>Average holding of at <span style="color:#6dfcd1">least ${eligibleAmount} SOLCAT</span> (based on two snapshots). \
      The first snapshot was taken on 1st July. The second snapshot will be taken at a random moment between 6th and 8th July.</p>`,
    token_name: 'BoopDoge',
    blockchain: 'Solana',
  },
  meta: {
    title: 'CatSolHat Super Airdrop',
    description:
      'Claim your SOLCAT airdrop: Early Contributors, Active Wallets on Solana DEXs, Saga Phone Buyers, Top NFT Collections Holders,...',
    thumbnail_url: '/thumbnail.png',
  },
  instruction: {
    stake_solcat: {
      title: 'Get SOLCAT & Connect',
      description:
        '<p style="margin:0">Grab your SOLCAT from any DEX. Then, connect your wallet to the staking platform and click <br/> <span class="font-dm_mono" style="color:#6dfcd1">STAKE NOW</span>.</p>',
    },
    staking_plan: {
      title: 'Choose Your Staking Plan',
      description:
        '<p style="margin:0">Choose between two staking options: <span class="font-dm_mono" style="color:#6dfcd1">Flexible</span> and <span class="font-dm_mono" style="color:#6dfcd1">Fixed</span>. Both offer great interest rates and earn you Launchpad Credit (LC).</p>',
    },
    reward: {
      title: 'Unlock Max Rewards',
      description:
        '<p style="margin:0">Fixed staking gives the highest interest rates and <span class="font-dm_mono" style="color:#6dfcd1">multiplied LC</span>, boosting your eligibility for launchpad presales and airdrops.</p>',
    },
  },
}

export default locale
